// next-themes 0.4 exports its prop types from the package root; the old
// 'next-themes/dist/types' subpath is no longer in its "exports" map.
import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from 'next-themes'

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      storageKey="ent-public-web-theme"
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}
